<template>
  <div class="item-box">
    <a :href="linkUrl" @click="onClickLink">
      <div class="item-card">
        <div class="item-card-icon">
          <ImgLazy
            :image-url="imageUrl"
            :alt-text="itemName"
            aspect-ratio="1 / 1"
          />
        </div>
        <div class="item-card-info">
          <LabelChips :labels="labels" />
          <div class="item-card__brand-name">
            {{ brandName }}
          </div>
          <div class="item-card__item-name">
            {{ itemName }}
          </div>
          <div v-if="hasMultipleItemSkus" class="item-card__item-sku-name">
            {{ itemSkuName }}
          </div>
          <div class="item-card__item-prices">
            <span class="item-card__currency-symbol">¥</span>
            <span class="item-card__item-price">{{ itemSkuPrice }}</span>
            <span v-if="isIncludingTax" class="item-card__item-tax">税込</span>
            <span v-if="soldOut" class="item-card__sold-out">
              入荷待ち
            </span>
          </div>
        </div>
        <div v-if="!soldOut" class="add-button-box">
          <button class="text-link add-button" @click="onClickAddButton">
            <span class="tl-plus-circle--left">
              {{ addButtonText }}
            </span>
          </button>
        </div>
      </div>
    </a>
  </div>
</template>
<script>
import ImgLazy from '../images/ImgLazy.vue'
import LabelChips from '../labels/LabelChips.vue'

export default {
  components: {
    ImgLazy,
    LabelChips
  },
  props: {
    linkUrl: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    brandName: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: false,
      default: ''
    },
    itemSkuPrice: {
      type: String,
      required: true
    },
    isIncludingTax: {
      type: Boolean,
      required: true
    },
    hasMultipleItemSkus: {
      type: Boolean,
      required: true
    },
    addButtonText: {
      type: String,
      required: false,
      default: '追加する'
    },
    soldOut: {
      type: Boolean,
      required: false,
      default: false
    },
    labels: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  methods: {
    onClickAddButton() {
      this.$emit('clicked-add-button')
    },
    onClickLink() {
      this.$emit('clicked-link')
    }
  }
}
</script>
<style lang="scss" scoped>
.item-box {
  width: 160px;
  flex-shrink: 0;

  a:hover {
    text-decoration: none;
  }
}

.label-chips {
  margin: 8px 0 0 0;
}

.item-card {
  @extend %hover-common;
  background-color: $white;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  border: 1px solid $gray-2;
  box-sizing: border-box;

  &-icon {
    // NOTE: inline-block 要素間の空白や改行などにあたる暗黙的なスタイルを回避するための対応
    font-size: 0;

    img {
      width: 100%;
      height: 100%;
    }
  }

  &-info {
    padding: 8px;
    background-color: $white;
    text-align: left;
  }

  &__brand-name {
    color: $gray-1;
    font-size: 1.2rem;
    line-height: 1.6;
    padding: 8px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__item-name {
    color: $black;
    white-space: normal;
    overflow-wrap: break-word;
    line-height: 1.6;
    font-size: 1.2rem;
    max-height: 3.84rem; // 2行分のため、1.2rem[font-size] x 1.6[line-height] x 2[行]
    font-weight: bold;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
  }

  &__item-sku-name {
    color: $black;
    font-size: 1.2rem;
    line-height: 1.6;
    padding-top: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: content-box;
    // NOTE: sku名がない場合も高さを保つため、heightを指定する。
    height: calc(1.2rem * 1.6);
  }

  &__item-prices {
    padding-top: 8px;
  }

  &__currency-symbol {
    font-weight: normal;
    font-size: 1rem;
    line-height: 1.6;
    color: $black;
  }

  &__item-price {
    font-weight: normal;
    font-size: 1.4rem;
    line-height: 1.6;
    color: $black;
  }

  &__item-tax {
    line-height: 1.6;
    font-size: 1rem;
    color: $black;
    margin-left: 2px;
  }

  &__sold-out {
    font-weight: bold;
    font-size: 1rem;
    line-height: 1.6;
    color: $gray-1;
    margin-left: 4px;
  }
}

.add-button-box {
  padding: 0 8px 16px 8px;
}
</style>
